import { Platform, StyleSheet } from 'react-native';

export const createMediaCardStyles = (colors, isSmall, isIconOnly) => StyleSheet.create({
  container: {
    position: 'relative',
    maxWidth:
      isIconOnly ?
        (isSmall ? 42 : 56) : isSmall ? 280 : 320,
  },
  mediaContainer: {
    width: isSmall ? 42 : 140,
    height: isSmall ? 42 : 140,
    backgroundColor: colors.solid_color_block,
    borderRadius: isSmall ? 8 : 12,
  },
  mediaContent: {
    width: '100%',
    height: '100%',
    borderRadius: isSmall ? 8 : 12,
    overflow: 'hidden',
  },
  documentContainer: {
    height: isSmall ? 42 : 56,
    paddingLeft: isIconOnly ? 2 : isSmall ? 4 : 6,
    paddingRight: isIconOnly ? 2 : isSmall ? 10 : 12,
    backgroundColor: colors.solid_color_block,
    borderWidth: 1,
    borderColor: colors.border_color_secondary,
    flexDirection: 'row',
    alignItems: 'center',
    gap: isSmall ? 6 : 8,
    // flex: 0, // Don't grow
    flexShrink: 1, // Allow shrinking
    minWidth:
      isIconOnly ?
        (isSmall ? 42 : 56) : 200,
    borderRadius: isSmall ? 8 : 12,
  },
  fileContent: {
    width: '100%',
    height: '100%',
    backgroundColor: colors.solid_color_block,
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
  imagePreview: {
    width: '100%',
    height: '100%',
    resizeMode: 'cover',
  },
  checkerboard: {
    position: 'absolute',
    opacity: 0.5,
    height: '100%',
    width: '100%',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: isSmall ? 8 : 12,
  },
  checkerImage: {
    resizeMode: 'repeat',
    height: '100%',
    width: '100%',
  },
  deleteButton: {
    position: 'absolute',
    top: -6,
    right: -6,
    width: 20,
    height: 20,
    borderRadius: 10,
    backgroundColor: colors.solid_color_primary,
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2,
    borderWidth: 1,
    borderColor: colors.border_color_secondary,
  },
  fileIconContainer: {
    width: isSmall ? 36 : 46,
    height: isSmall ? 36 : 46,
    borderRadius: isSmall ? 8 : 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  fileTextContainer: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    overflow: 'hidden',
    minWidth: 0,
  },
  fileName: {
    color: colors.text_color_primary,
    fontSize: 14,
    minWidth: 0,
    maxWidth: '100%',
    ...(Platform.OS === 'web' ? {
      overflowWrap: 'anywhere',
      wordBreak: 'break-word',
    } : {}),
  },
  fileType: {
    display: 'flex',
    flexShrink: 0,
    color: colors.text_color_secondary,
    fontSize: 12,
    marginTop: isSmall ? 1 : 2,
    minWidth: 40,
  },
  fileDot: {
    display: 'flex',
    flexShrink: 0,
    color: colors.text_color_secondary,
    fontSize: 12,
    marginTop: isSmall ? 1 : 2,
  },
  centerOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: isSmall ? 8 : 12,
  },
  loadingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: isSmall ? 8 : 12,
  },
});
